import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=6373201a&scoped=true&"
import script from "./Arrow.vue?vue&type=script&lang=js&"
export * from "./Arrow.vue?vue&type=script&lang=js&"
import style0 from "./Arrow.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Arrow.vue?vue&type=style&index=1&id=6373201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373201a",
  null
  
)

export default component.exports